import React from "react"

export const FacebookPost = ({ content }) => {
  let FacebookPostBody = []
  if (typeof window !== "undefined") {
    window.dataLayer.push({
      event: "give_me_facebook",
      requires_facebook: true,
    })
    FacebookPostBody.push(
      <div className="column has-text-centered">
        <div className="fb-root"></div>
        <div className="fb-post" data-href={content}></div>
      </div>
    )
  }

  return <div className="columns is-centered">{FacebookPostBody}</div>
}
